import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { isString } from '../util/validator.util';
import { BasicDialogService } from './basic-dialog.service';

@Injectable()
export class DeleteDialogService extends BasicDialogService{
    constructor(
        protected translateService: TranslateService
    ) { 
        super(translateService);
    }

    askPermission(){
        return Swal.fire({
          title: this.translateService.instant('COMMON.LIST.DIALOGS.DELETE.TITLE'),
          text: this.translateService.instant('COMMON.LIST.DIALOGS.DELETE.TEXT'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.translateService.instant('COMMON.LIST.DIALOGS.DELETE.CONFIRM_BTN'),
          cancelButtonText: this.translateService.instant('COMMON.LIST.DIALOGS.DELETE.CANCEL_BTN'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger ml-1'
          }
        });
    }

    success(msg = null){
        if(!isString(msg)) msg = this.translateService.instant('COMMON.LIST.DIALOGS.DELETE.SUCCESS.TEXT')
        return Swal.fire({
            title: this.translateService.instant('COMMON.LIST.DIALOGS.DELETE.SUCCESS.TITLE'),
            text: msg,
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-success'
            }
        });
    }

    cancel(msg = null){
        if(!isString(msg)) msg = this.translateService.instant('COMMON.LIST.DIALOGS.DELETE.CANCEL.TEXT')
        return Swal.fire({
            title: this.translateService.instant('COMMON.LIST.DIALOGS.DELETE.CANCEL.TITLE'),
            text: msg,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            }
        });
    }
}